export default __webpack_public_path__ + "static/google-sheets-00601a83e3924034d3cf221da155e6a5.svg";